import React from "react";

import { getCareerLink, getContactLink, goTo, useTranslation, useUserContext } from "utils";

import { COUNTRY_CODE } from "consts";

import { Button, Col, Icon, Row, Typography } from "components";

const ContactFooter: React.FC = () => {
  const { t } = useTranslation(["dashboard", "meta"]);
  const { user } = useUserContext();

  const contactButtons = [
    {
      translationKey: "contact.contact",
      iconName: "tabler/writing",
      action: () => goTo(null, null, getContactLink(), true),
    },
    {
      translationKey: "contact.career",
      iconName: "klim/heart-handshake",
      action: () => window.open(getCareerLink(), "_blank", "noopener,noreferrer"),
    },
    {
      translationKey: "contact.feedback",
      iconName: "tabler/help",
      action: () => goTo(null, null, process.env.REACT_APP_TYPEFORM, true),
      isHidden: user?.farm?.country !== COUNTRY_CODE.GERMANY,
    },
  ];

  return (
    <section className="padding-top-150 padding-bottom-400 margin-bottom-350">
      <Row>
        <Col sm={24} xs={24}>
          <Typography variant="h3">{t("info.title")}</Typography>
        </Col>
      </Row>
      <Row>
        <Col sm={12} xs={24}>
          <Typography variant="paragraph-m" className="deep-black-text">
            {t("info.description")}
          </Typography>
        </Col>
        <Col sm={12} xs={24}>
          {contactButtons.map((button) =>
            button && !button.isHidden ? (
              <Button key={button.iconName} className="contact-footer-button" onClick={button.action}>
                <Icon iconName={button.iconName} />
                <div className="contact-footer-button-text">{t(button.translationKey)}</div>
                <Icon iconName="tabler/chevron-right" />
              </Button>
            ) : null
          )}
        </Col>
      </Row>
    </section>
  );
};

export default ContactFooter;
